<script>
import { computed } from 'vue';
import tagging from '../lib/tagging/mixin';
import { common as commonProps, tagging as taggingProps } from './prop-definitions';

export default {
  name: 'refapp-hotspots-provider',
  mixins: [tagging],
  provide() {
    return Object.keys({
      ...commonProps,
      ...taggingProps,
    }).reduce((acc, curr) => {
      acc[curr] = computed(() => this[curr]);
      return acc;
    }, {});
  },
  props: {
    ...commonProps,
    ...taggingProps,
  },
  render() {
    const isVue3Slot = this.$slots.default instanceof Function;

    if (isVue3Slot) {
      return this.$slots.default();
    }

    return this.$slots.default;
  },
};
</script>
